import getAuthLink from 'src/apollo/queries/getAuthLink.gql'
import { useHelpers } from 'src/common/composition/useHelpers'

export function initCDA(apolloClient, store) {
  const hasCDA = process.env.VUE_APP_CDA_URL && process.env.WEBVIEW !== '1'
  const token = store.getters.getToken

  if (!hasCDA || !token) {
    return
  }

  sessionStorage.setItem('redirect2cda', 'true')

  const $helpers = useHelpers()
  const isIOSPlatform = $helpers.platform.is.ios

  if (isIOSPlatform) {
    return initCDAForIOS(apolloClient)
  } else {
    initCDAForOtherPlatforms(apolloClient)
  }
}

async function initCDAForIOS(apolloClient) {
  try {
    const authLink = await fetchAuthLink(apolloClient)
    if (!authLink) {
      return
    }

    if (!slugsIsChanged(authLink)) {
      return
    }

    const linkTail = getTailForCdaLink(authLink)
    setForIOS(linkTail)
  } catch (e) {
    console.error(e)
  }
}

function initCDAForOtherPlatforms(apolloClient) {
  fetchAuthLink(apolloClient)
    .then((authLink) => {
      if (!authLink) {
        return
      }

      if (!slugsIsChanged(authLink)) {
        return
      }

      const linkTail = getTailForCdaLink(authLink)
      setCookiesByIframe(linkTail)
      setCookiesByImage(linkTail)
    })
    .catch((e) => {
      console.error(e)
    })
}

function fetchAuthLink(apolloClient) {
  return apolloClient
    .query({
      query: getAuthLink,
      fetchPolicy: 'network-only',
    })
    .then(({ data }) => data.authLink)
    .catch((e) => {
      console.error('Error fetching authLink:', e)
      return null
    })
}

function slugsIsChanged(authLink) {
  const CDA_KEY = 'cda-key'
  const oldCdaKey = localStorage.getItem(CDA_KEY)
  const key = authLink.uuid + authLink.uuidSecond

  if (oldCdaKey !== key) {
    localStorage.setItem(CDA_KEY, key)
    return true
  }
  return false
}

function getTailForCdaLink(data) {
  const hashStr = encodeURIComponent(data.hashStr)
  return `?slug=${data.uuid}&slug2=${data.uuidSecond}&hashstr=${hashStr}`
}

function setForIOS(linkTail) {
  window.location.replace(getRedirectLink(linkTail))
}

function getSimpleLink(tailForCda) {
  return `${process.env.VUE_APP_CDA_URL}slug/${tailForCda}`
}

function getRedirectLink(tailForCda) {
  return `${process.env.VUE_APP_CDA_URL}slug-r/${tailForCda}`
}

function setCookiesByIframe(linkTail) {
  const link = getSimpleLink(linkTail)

  const iframe = document.createElement('iframe')
  iframe.src = link
  iframe.name = 'cookiesHackFrame'
  iframe.style = 'display: none'

  const formElement = document.createElement('form')
  formElement.action = link
  formElement.id = 'cookiesHackForm'
  formElement.method = 'post'
  formElement.target = 'cookiesHackFrame'
  formElement.style = 'display: none'

  const body = document.querySelector('body')
  iframe.onload = function () {
    formElement.submit()
    iframe.remove()
    formElement.remove()
  }

  body.appendChild(iframe)
  body.appendChild(formElement)
}

function setCookiesByImage(linkTail) {
  const image = document.createElement('img')
  image.src = getSimpleLink(linkTail)
  image.style = 'opacity: 0; position: absolute; left: -999px; width: 1px; height: 1px'

  image.onload = function () {
    image.remove()
  }
  image.onerror = function () {
    image.remove()
  }

  const body = document.querySelector('body')
  body.appendChild(image)
}
